/*
 * @Author: wangxiang 
 * @Date: 2019-11-11 13:42:02 
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-11-13 19:26:45
 */
import placeholderImg from './t-default-bg.png';

export default {
  name: 't-picture',
  render() {
    const style = {
      borderRadius: this.borderRadius
    };

    return <img style={style} src={this.imgSrc || placeholderImg} alt="" srcset="" width="100%" />
  },
  props: {
    imgSrc: {
      type: String,
      default: placeholderImg
    },
    borderRadius: {
      type: String,
      default: '100%'
    }
  },
  data: () => ({
    placeholderImg
  }),
  editorConfig: {
    propsConfig: {
      imgSrc: {
        type: 'image-gallery',
        label: '图片url',
        prop: {
          type: 'textarea'
        },
        defaultPropValue: ''
      },
      borderRadius: {
        type: 'a-input',
        label: '设置图片',
        defaultPropValue: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/album/plugins/t-picture.js